import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { AutonomousActivitySwitcher } from "portal/components/atk/AutonomousActivitySwitcher";
import { AutonomousActivityType } from "protos/atk/enums";
import { FormikDimensionedNumberInput } from "common/components/FormikDimensionedNumberInput";
import { RigDetailsFormState } from "../FormState";
import { typedPath } from "typed-path";
import { useSelf } from "portal/state/store";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useState } from "react";

const S = typedPath<RigDetailsFormState>();

export const AutonomousActivitiesSubform: React.FC<{ readOnly: boolean }> = ({
  readOnly,
}) => {
  const { t } = useTranslation();
  const { measurementSystem } = useSelf();
  const [viewingActivity, setViewingActivity] =
    useState<AutonomousActivityType>(
      AutonomousActivityType.ACTIVITY_WORKING_ROW
    );

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {t("views.autotractor.autonomousActivities.title")}
      </AccordionSummary>
      <AccordionDetails className="grid grid-cols-2 gap-4">
        <AutonomousActivitySwitcher
          variant="with-descriptions"
          activeActivity={viewingActivity}
          setActiveActivity={setViewingActivity}
        />
        <FormikDimensionedNumberInput
          className="w-full"
          label={t("views.autotractor.autonomousActivities.minTransitionSpeed")}
          tooltipText={t(
            "views.autotractor.autonomousActivities.minTransitionSpeedTooltip"
          )}
          name={
            S.atkConfig.activities.activities[viewingActivity]
              .minTransitionVelocityMps.$path
          }
          dimensionedNumberInputProps={{
            storedUnit: "m/s",
            displayUnits: {
              imperial: "mph",
              metric: "km/h",
            },
            localSystem: measurementSystem,
            textFieldProps: {
              size: "medium",
            },
            disabled: readOnly,
          }}
        />
        <FormikDimensionedNumberInput
          className="w-full"
          label={t("views.autotractor.autonomousActivities.maxTransitionTime")}
          tooltipText={t(
            "views.autotractor.autonomousActivities.maxTransitionTimeTooltip"
          )}
          name={
            S.atkConfig.activities.activities[viewingActivity]
              .maxTransitionWaitS.$path
          }
          dimensionedNumberInputProps={{
            storedUnit: "s",
            displayUnits: {
              imperial: "s",
              metric: "s",
            },
            localSystem: measurementSystem,
            textFieldProps: {
              size: "medium",
            },
            disabled: readOnly,
          }}
        />
      </AccordionDetails>
    </Accordion>
  );
};
